import React from 'react'
import { TableCell, TableSortLabel } from '@mui/material'

export const SortableHeader = ({ column, label, sort, onSort, align }) => (
  <TableCell align={align} sortDirection={sort.column === column ? sort.direction : false}>
    <TableSortLabel
      active={sort.column === column}
      direction={sort.column === column ? sort.direction : 'asc'}
      onClick={() => onSort(column)}
    >
      {label}
    </TableSortLabel>
  </TableCell>
)
